import { IconType } from 'react-icons';
import { ReportingControllerBaseConfig } from '../../../base';
import { TemplateSelectController } from './templateSelectInterface';
import { TemplateItemViewProps } from '../item';

export function createTemplateSelectController(
    config: ReportingControllerBaseConfig & {
        icons: {
            byId: Record<string, { Icon: IconType } | undefined>;
            default: IconType;
        };
    }
): TemplateSelectController {
    return {
        useProps(context, item, props) {
            return {
                items: item.items.map((item) => ({
                    id: item.id,
                    label: item.displayName,
                    description: item.caption,
                    icon: config.icons.byId[item.id]?.Icon ?? config.icons.default,
                    isSelected: props.value === item.id,
                    onClick() {
                        props.onChange(props.value === item.id ? null : item.id);
                    },
                })),
            };
        },
    };
}
